module.exports = __webpack_public_path__ + "static/media/PinEmpty.70091398.svg";